// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import BootstrapVue from "bootstrap-vue";

import Toasted from "vue-toasted";
import Datepicker from "vuejs-datepicker";
import VueLazyload from "vue-lazyload";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "./filters/filters";

import VueCookie from "vue-cookie";
Vue.use(VueCookie);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// mixin
import Mixin from "@/util/utilMixin";

import "./assets/css/style.css";
import "./assets/css/button.css";

import "./assets/css/icons.css";
import "./assets/css/installation.css";
import "./assets/css/akash.css";
import "./assets/css/theme.css";
import "./assets/css/mobileDashboard.css";

import { BASEURL } from "@/config/index";
import axios from "axios";

import "vue-multiselect/dist/vue-multiselect.min.css";
import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

// import VueChartJS from "vue-chartjs";
// Vue.use(VueChartJS);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "/static/placeholder-image.png",
  loading: "/static/placeholder-image.png",
  attempt: 1,
});

// added loader
Vue.use(Loading, {
  loader: "bars",
  color: "#c74c47",
  width: 70,
  zIndex: 9999,
  height: 50,
  backgroundColor: "#4b4b4b",
});
Vue.mixin(Mixin);
Vue.use(BootstrapVue);
Vue.component("Datepicker", Datepicker);

Vue.config.productionTip = false;

// toast message
Vue.use(Toasted, {
  duration: 2000,
  position: "bottom-center",
  singleton: true,
  containerClass: "toast-message",
  className: "toastedContainer",
});

// Created the Event Bus for the call parent function
export const EventBus = new Vue();

// socket import

/* eslint-disable no-new */
let vm = new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: {
    App,
  },
});



// WEBPACK FOOTER //
// ./src/main.js